import React, { useState, useEffect } from 'react';
import { fetchData, postData, deleteData } from '../utils/api';
import '../css/ExecutiveOfficerManagement.css';

const ExecutiveOfficerManagement = ({ onClose }) => {
    const [officers, setOfficers] = useState([]);
    const [newOfficerName, setNewOfficerName] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        loadOfficers();
    }, []);

    const loadOfficers = async () => {
        try {
            const data = await fetchData('/api/executive-officers');
            setOfficers(data);
            setLoading(false);
        } catch (err) {
            setError('Failed to load executive officers');
            setLoading(false);
        }
    };

    const handleAddOfficer = async (e) => {
        e.preventDefault();
        if (!newOfficerName.trim()) return;

        try {
            const newOfficer = await postData('/api/executive-officers', { name: newOfficerName });
            setOfficers([...officers, newOfficer]);
            setNewOfficerName('');
        } catch (err) {
            if (err.message.includes('409')) {
                alert('Executive officer already exists');
            } else {
                alert('Failed to add executive officer');
            }
        }
    };

    const handleDeleteOfficer = async (id) => {
        if (!window.confirm('Are you sure you want to delete this executive officer?')) return;

        try {
            await deleteData(`/api/executive-officers/${id}`);
            setOfficers(officers.filter(officer => officer.id !== id));
        } catch (err) {
            alert('Failed to delete executive officer');
        }
    };

    return (
        <div className="executive-officer-card">
            <div className="card-header-custom">
                <div className="d-flex align-items-center">
                    <div className="icon-wrapper">
                        <i className="bi bi-briefcase-fill"></i>
                    </div>
                    <div>
                        <h3>Executive Officers</h3>
                        <p className="subtitle">Manage authorized signatories</p>
                    </div>
                </div>
                {onClose && (
                    <button onClick={onClose} className="close-btn-custom" title="Close">
                        <i className="bi bi-x-lg"></i>
                    </button>
                )}
            </div>

            <div className="card-body-custom">
                {error && (
                    <div className="alert-custom error">
                        <i className="bi bi-exclamation-triangle-fill"></i> {error}
                    </div>
                )}

                <form onSubmit={handleAddOfficer} className="add-officer-form-custom">
                    <div className="input-group-custom">
                        <span className="input-icon"><i className="bi bi-person-plus"></i></span>
                        <input
                            type="text"
                            value={newOfficerName}
                            onChange={(e) => setNewOfficerName(e.target.value)}
                            placeholder="Enter new officer name..."
                            required
                        />
                    </div>
                    <button type="submit" className="add-btn-custom">
                        <i className="bi bi-plus-lg"></i> Add Officer
                    </button>
                </form>

                {loading ? (
                    <div className="loading-state">
                        <div className="spinner-border text-primary" role="status"></div>
                        <span className="ms-2">Loading list...</span>
                    </div>
                ) : (
                    <div className="officers-list-container">
                        {officers.length === 0 ? (
                            <div className="empty-state">
                                <i className="bi bi-people"></i>
                                <p>No executive officers added yet.</p>
                                <small>Add names to populate the dropdown list.</small>
                            </div>
                        ) : (
                            <ul className="officer-list-custom">
                                {officers.map((officer, index) => (
                                    <li key={officer.id} style={{ animationDelay: `${index * 0.05}s` }}>
                                        <div className="officer-info">
                                            <div className="avatar-initials">
                                                {officer.name.charAt(0).toUpperCase()}
                                            </div>
                                            <span className="officer-name">{officer.name}</span>
                                        </div>
                                        <button
                                            onClick={() => handleDeleteOfficer(officer.id)}
                                            className="delete-btn-custom"
                                            title="Remove Officer"
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExecutiveOfficerManagement;
